<template>
  <v-container fluid>
    <v-col cols="12" sm="12" offset-sm="0">
      <v-card class="maincard" :loading="loading">
        <v-container fluid>
          <v-row align="center">
            <v-col cols="12" xs="12" sm="9">
              <v-card-title>Mail Templates</v-card-title>
            </v-col>

            <v-col cols="12" xs="12" sm="3" style="text-align: right;">
              <v-btn to="/pdftemplates/edit/" color="success">
                <v-icon style="margin-right: 10px;">mdi-plus</v-icon>
                <span>Neues Template</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <v-container fluid>
          <v-card>
            <v-container fluid>
              <v-card outlined>
                <v-row class="pa-4">
                  <v-col sm="12">
                    <v-text-field
                      label="Template suchen"
                      dense
                      v-model="itemSearch"
                      name="suche"
                      outlined
                      clearable
                    />
                  </v-col>
                </v-row>
              </v-card>
            </v-container>

            <TemplateCardList
              :items="templateList"
              @deleteItem="askDeleteTemplate"
              @editItem="editItem"
            />
          </v-card>
        </v-container>
      </v-card>
    </v-col>
    <v-dialog v-model="dlgDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Template löschen?</v-card-title>
        <v-card-text>
          Soll das Template
          <strong>{{ deleteTemplateName }}</strong> wirklich gelöscht werden?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" outlined text @click="dlgDelete = false"
            >Abbrechen</v-btn
          >
          <v-btn dark color="red darken-1" @click="deleteTemplate">
            <v-icon>mdi-delete</v-icon>Löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// @ is an alias to /src
import TemplateCardList from "@/components/settings/TemplateCardList";

export default {
  name: "MailTemplateMgmt",
  data: () => ({
    loading: false,
    dlgDelete: false,
    deleteItem: false,
    deleteTemplateName: "",
    dlgImport: false
  }),
  components: { TemplateCardList },
  methods: {
    checkAccess(role) {
      const user = this.$store.getters["user/getUser"];

      if (!user) {
        return false;
      }
      if (
        user.role === this.$store.getters["user/userRoles"].userRole.SuperUser
      ) {
        return true;
      } else if (user.role === role) {
        return true;
      } else {
        return false;
      }
    },
    askDeleteTemplate(item) {
      this.deleteTemplateName = item.name;
      this.dlgDelete = true;
      this.deleteItem = item;
    },
    editItem(item) {
      this.$router.push({
        name: "mailtemplate-edit",
        params: { id: item._id }
      });
    },

    deleteTemplate() {
      this.dlgDelete = false;
      this.$store
        .dispatch("meal/deleteTemplate", this.deleteItem._id)
        .then(() => {
          this.$notify({
            group: "dataline",
            type: "info",
            title: "Template gelöscht",
            text: "Template " + this.deleteItem.name + " wurde gelöscht"
          });
          this.deleteTemplateName = "";
        });
    },
    loadTemplates() {
      this.loading = true;
      this.$store
        .dispatch("mailTemplate/fetchTemplates")
        .then(() => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          if (error.response.status != 401) {
            this.$notify({
              group: "dataline",
              type: "error",
              title: "Fehler",
              text: error.message
            });
          }
        });
    }
  },
  computed: {
    templateList() {
      return this.$store.getters["mailTemplate/getTemplateList"];
    },
    itemSearch: {
      get() {
        return this.$store.getters["mailTemplate/getSearch"];
      },
      set(value) {
        this.$store.commit("mailTemplate/SET_SEARCH", value);
      }
    }
  },
  created() {
    this.loadTemplates();
  }
};
</script>
<style scoped></style>
